import type { SVGProps } from "react";

export function IconWhiteArrowRight(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        d="M12.5601 32H26.5601M12.5601 7L57.0045 32L12.5601 57V7Z"
        stroke="#23232C"
        strokeWidth="1.5625"
        strokeLinecap="square"
      />
    </svg>
  );
}
